import React, { useState, useEffect, useCallback } from 'react'
import { purchaseListPromise } from 'api/Purchase'
import PerfectScrollbar from 'react-perfect-scrollbar'
import PropTypes from 'prop-types'
import { formatDateTime } from 'common/usual'
import {
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
} from '@material-ui/core'

function PurchaseTable (props) {
  const { userId } = props
  const [purchase, setPurchase] = useState({})
  const [page, setPage] = useState(1)

  const fetchPurchase = useCallback(async () => {
    setPurchase(await purchaseListPromise({ page, userId, size: 10 }))
  }, [page, userId])

  const handlePageChange = (event, page) => {
    setPage(page+1)
  }

  useEffect(() => {
    fetchPurchase()
  }, [fetchPurchase])

  return (
    <Card>
      <CardContent className={'table-content'}>
        <PerfectScrollbar>
          <div className={'inner'}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>SKU</TableCell>
                  <TableCell>Expire</TableCell>
                  <TableCell>OS Type</TableCell>
                  <TableCell>Promotion</TableCell>
                  <TableCell>Created At</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  (purchase.rows || []).map(row => (
                    <TableRow key={row.id}>
                      <TableCell>{row.id}</TableCell>
                      <TableCell>{row.sku}</TableCell>
                      <TableCell>{formatDateTime(row.expire)}</TableCell>
                      <TableCell>{row.os_type_text}</TableCell>
                      <TableCell>{row.in_promo ? 'TRUE' : 'FALSE'}</TableCell>
                      <TableCell>{formatDateTime(row.created_at)}</TableCell>
                    </TableRow>
                  ))
                }
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={'actions'}>
        <TablePagination
          component="div"
          count={purchase.count || 0}
          onChangePage={handlePageChange}
          page={page-1}
          rowsPerPage={10}
          rowsPerPageOptions={[10]}
        />
      </CardActions>
    </Card>
  )
}

PurchaseTable.propTypes = {
  userId: PropTypes.any.isRequired
}

export default PurchaseTable